import type { IServiceMap } from '../services';
import { EServiceItemIds } from '../types';
import { CampaignManagement } from './campaign_management';
import { CreativeMigrationPack } from './creative_migration_pack';
import { DataIntegration } from './data_integration';
import { EmailSwitchKit } from './email_switch_kit';
import { ManagedServicesGoogleAdsGrants } from './managed_services_google_ads_grants';
import { PlatformImplementationAndOnboarding } from './platform_implementation_and_onboarding';
import { Pro } from './pro';
import { Training } from './training';

export const serviceIdToNameMap: Record<EServiceItemIds, string> = {
  [EServiceItemIds.CampaignManagement]: 'campaignManagement',
  [EServiceItemIds.CreativeMigrationPack]: 'creativeMigrationPack',
  [EServiceItemIds.DataIntegration]: 'dataIntegrationServices',
  [EServiceItemIds.EmailSwitchServiceKit]: 'emailSwitchServiceKit',
  [EServiceItemIds.ManagedServicesGoogleAdGrantManagement]:
    'managedServicesGoogleAdGrantManagement',
  [EServiceItemIds.PlatformImplementationAndOnboarding]: 'platformImplementationAndOnboarding',
  [EServiceItemIds.Training]: 'training',
  [EServiceItemIds.Pro109]: 'pro',
  [EServiceItemIds.Pro112]: 'pro',
  [EServiceItemIds.Pro117]: 'pro',
  [EServiceItemIds.Pro118]: 'pro',
  [EServiceItemIds.CoPilotLegacy]: 'coPilotLegacy',
};

export type ServiceNameKeys = (typeof serviceIdToNameMap)[EServiceItemIds];

const serviceMap = {
  [EServiceItemIds.CampaignManagement]: CampaignManagement,
  [EServiceItemIds.CreativeMigrationPack]: CreativeMigrationPack,
  [EServiceItemIds.DataIntegration]: DataIntegration,
  [EServiceItemIds.EmailSwitchServiceKit]: EmailSwitchKit,
  [EServiceItemIds.ManagedServicesGoogleAdGrantManagement]: ManagedServicesGoogleAdsGrants,
  [EServiceItemIds.PlatformImplementationAndOnboarding]: PlatformImplementationAndOnboarding,
  [EServiceItemIds.Training]: Training,
  [EServiceItemIds.Pro109]: Pro,
  [EServiceItemIds.Pro112]: Pro,
  [EServiceItemIds.Pro117]: Pro,
  [EServiceItemIds.Pro118]: Pro,
} as Record<Exclude<EServiceItemIds, 'CoPilotLegacy'>, IServiceMap>;

export function getServices(
  serviceIds: EServiceItemIds[],
): Record<string, IServiceMap | undefined> {
  return Object.entries(serviceIdToNameMap).reduce(
    (acc, [serviceId, serviceName]) => {
      if (serviceIds.includes(serviceId as EServiceItemIds)) {
        acc[serviceName] = serviceMap[serviceId as Exclude<EServiceItemIds, 'CoPilotLegacy'>];
      } else {
        acc[serviceName] = undefined;
      }
      return acc;
    },
    {} as Record<string, IServiceMap | undefined>,
  );
}

export {
  CampaignManagement,
  CreativeMigrationPack,
  DataIntegration,
  EmailSwitchKit,
  ManagedServicesGoogleAdsGrants,
  PlatformImplementationAndOnboarding,
  Pro,
  Training,
};
